module.exports = __webpack_public_path__ + "img/computer_2.c0a25a4a.png";